import { styled } from 'troyfe';

const Wrap = styled.div`
  width: 100%;
  position: relative;
  .tip-text {
    font-size: 1.6rem;
  }
  .query-form {
    padding-top: 1.5rem;
    .form {
      .ant-col {
        margin-bottom: 0.5rem;
      }
      .ant-form-item {
        margin-bottom: 0;
      }
      input {
        font-size: 1.6rem;
      }
      .ant-picker {
        height: 4.8rem;
      }
      .ant-select-single .ant-select-selector .ant-select-selection-item {
        line-height: 4.8rem;
        height: 4.8rem;
      }
      .ant-input-affix-wrapper {
        padding: 0 0.69rem;
        height: 4.8rem;
      }
      .ant-select-selector {
        height: 4.8rem;
        color: #1b1b1d;
      }
      .ant-select-selection-placeholder {
        line-height: 4.8rem;
        font-size: 1.6rem;
      }
      .ant-form-item-label {
        width: 25%;
      }
      .address {
        .ant-form-item-label {
          width: 8%;
        }
      }
      .address_group {
        width: 63%;
      }
      .ant-form-item-label > label {
        height: 4.8rem;
        font-size: 1.6rem;
        justify-content: end;
      }
    }
    .header-handle {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      margin: 0 1.25rem 1.5rem 0;
      .but {
        min-width: 12rem;
        height: 4.8rem;
        margin-left: 2rem;
        color: #ffffff;
        font-size: 1.6rem;
        border: none;
        border-radius: 0.25rem;
        background: #44bb55;
        border: 0.06rem solid #44bb55;
      }
      .nothing {
        background: none;
        color: #44bb55;
      }
    }
  }
  .tableBox {
    padding: 0 1.25rem 1.25rem;
    .operation {
      display: flex;
      align-items: center;
      margin: 0;
      li {
        color: #44bb55;
      }
      i {
        width: 0.06rem;
        background: #999999;
        height: 1rem;
        margin: 0 1.6rem;
      }
      li:hover {
        cursor: pointer;
      }
    }
  }
`;

const DrawerStyle = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;

  .drawer-top {
    padding: 1.31rem 0;
    border-bottom: 0.06rem solid #f1f2f4;
    h1 {
      text-align: center;
      color: #333333;
      font-size: 1.8rem;
      font-weight: 540;
    }
    .clear {
      float: right;
      font-size: 1rem;
      width: 1.38rem;
      cursor: pointer;
      font-weight: 500;
      margin-right: 2rem;
      transform: scale(1.8);
    }
  }
  .drawer-content {
    flex: 1;
    .form {
      width: 74%;
      margin: 2.5rem auto;
      input {
        height: 4.8rem;
        font-size: 1.6rem;
      }
      .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector input {
        cursor: auto;
        height: 4.8rem;
      }
      .ant-form-item-label {
        width: 24%;
      }
      .ant-form-item-label > label {
        height: 4.8rem;
        justify-content: end;
        font-size: 1.6rem;
        font-weight: 500;
      }
      .ant-picker {
        line-height: 4.8rem;
        height: 4.8rem;
      }
      .ant-input-affix-wrapper {
        padding: 0 0.69rem;
        height: 4.8rem;
      }
      .ant-select-single .ant-select-selector .ant-select-selection-item {
        height: 4.8rem;
        line-height: 4.8rem;
        font-size: 1.6rem;
      }
      .ant-select-selector {
        height: 4.8rem;
        color: #1b1b1d;
        font-size: 1.6rem;
      }
      .ant-select-selection-placeholder {
        line-height: 4.8rem;
      }
      .labelName {
        .ant-form-item-required {
          display: none;
        }
      }
    }
    .list {
      margin: 3rem 6.2rem 0;
      li {
        display: flex;
        min-height: 4.8rem;
        label {
          text-align: right;
          width: 25%;
          color: #1b1b1d;
          font-size: 1.6rem;
          font-weight: 550;
        }
        div {
          flex: 1;
          font-size: 1.6rem;
        }
      }
    }
  }

  /* 提交按钮 */
  .handle {
    width: 100%;
    background: #fff;
    display: flex;
    justify-content: center;
    border-top: 0.06rem solid #f1f2f4;
    padding: 0.94rem 0;
  }
  .cancel,
  .confirm {
    width: 12rem;
    height: 4.8rem;
  }
  .cancel {
    background: #fff;
    border: 0.06rem solid #44bb55;
    color: #44bb55;
  }
  .confirm {
    margin-left: 2rem;
    background-color: #44bb55;
    border-color: #44bb55;
    color: #fff;
  }
`;

const ApplyStyle = styled.div`
  width: 100%;
  .empty {
    margin-top: 6rem;
    text-align: center;
    color: #999999;
    font-size: 1.8rem;

    span {
      color: #999999;
    }
  }

  .project-query {
    .inp {
      height: 4.8rem;

      .ant-input-group {
        height: 4.8rem;
      }

      .ant-input-affix-wrapper,
      .ant-input-group-addon {
        height: 100%;
      }

      input {
        height: 100%;
      }

      button {
        background: #44bb55;
        border-radius: 0 0.4rem 0.4rem 0;
        width: 12rem;
        border: #44bb55;
        height: 4.8rem;
      }
    }

    margin: auto;
    width: 70%;
    padding-bottom: 2.5rem;
  }

  .project {
    box-shadow: 0 0.2rem 0.8rem 0 rgba(8, 120, 24, 0.3);
    height: 45vh;
    overflow: scroll;
    overflow-x: hidden;
    padding: 0 2rem;

    li {
      padding: 2.2rem 0;
      position: relative;
      display: flex;
      align-items: center;
      border-bottom: 0.1rem solid #e2e2e2;
      cursor: pointer;

      img {
        display: inline-block;
        width: 5.6rem;
        height: 5.6rem;
      }

      .project-text {
        flex: 1;
        margin-left: 1.2rem;
        text-align: left;
      }

      .project-but {
        border-radius: 2rem;
        background: #44bb55;
        font-weight: 500;
        width: 12rem;
        padding: 0.6rem 1rem;
        font-size: 1.8rem;
        color: #ffffff;
      }

      &:hover {
        border-bottom: 0.1rem solid #44bb55;
      }
    }
  }

  .paging {
    margin-top: 2rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .total {
      margin-right: 1.5rem;
    }
  }
`;
export { Wrap, DrawerStyle, ApplyStyle };
